import { useState } from "react";
import LoginScreen from "./components/LoginScreen";
import GameScreen from "./components/GameScreen";
// import EndGameScreen from './components/EndGameScreen';
import Header from "./components/Header";
import { sc } from "./helper/constants";
import { useLocalStorage } from "./helper/useLocalStorage";

function App() {
  const [names, setNames] = useLocalStorage("player-names", {
    player1: "",
    player2: "",
  });
  const [score, setScore] = useLocalStorage("player-score", {
    player1: 0,
    player2: 0,
    ties: 0,
  });
  const [history, setHistory] = useLocalStorage("history", []);
  const [screen, setScreen] = useState(() => {
    if (names.player1 === "" || names.player2 === "") return sc.login;
    else return sc.board;
  });

  return (
    <div className="App">
      {screen === sc.login && (
        <LoginScreen
          names={names}
          setNames={setNames}
          setHistory={setHistory}
          setScreen={setScreen}
          setScore={setScore}
        />
      )}
      {screen === sc.board && <Header names={names} score={score} />}
      {screen === sc.board && (
        <GameScreen
          names={names}
          score={score}
          setScore={setScore}
          history={history}
          setHistory={setHistory}
          setScreen={setScreen}
        />
      )}
    </div>
  );
}

export default App;
